import { Button, Divider, Stack, Typography } from '@mui/material';
import { useCollection, useUploadFile, useWrite } from 'ember';
import { FormProvider, useForm } from 'react-hook-form';
import { cuid, useAuthData, DateTime } from 'stuff';
import { User } from 'types';
import ActionTypeSelect from './ActionType/ActionTypeSelect';
import ActionCollaborators from './Collaborators/ActionCollaborators';
import Inquiry from './Inquiry/Inquiry';
import { Action, ActionStatus, ActionType, Issue } from 'models';
import { StorageFile } from 'models';
import { Event } from 'types';
import { Attachments } from 'pages/createIssue/createIssueStepper/components/Attachments';


export interface CreateActionForm
{
	_id: string,
	inquiryMode?: 'list' | 'string',
	inquiry: string,
	todos: {
		label: string;
	}[],
	action_type: ActionType,
	due_date?: string,
	files: File[],
	collaborators: User[],
}


const CreateAction = ({
	action_metadata,
	closeDialog,
	setCloseDialog,
} : {
	action_metadata: Object,
	closeDialog?: boolean
	setCloseDialog: React.Dispatch<React.SetStateAction<boolean>>,
}) =>
{
	const { claims } = useAuthData();
	const uploadFile = useUploadFile();
	
	const write = useWrite();
	
	
	const current_user = {
		_id: claims.user_id,
		name: claims.name,
		email: claims.email,
	};
	
	
	const users_collection_path = `organizations/${claims?.organization_id}/users`;
	const users_collection = useCollection(users_collection_path)
	const users = (users_collection?.data as User[]) || [];
	
	
	const form = useForm<CreateActionForm>({
		defaultValues: {
			_id: cuid(),
			inquiry: '',
			action_type: null,
			todos: [],
			collaborators: [],
			files: [],
		}
	});
	
	const control = form.control;
	
	
	const handleSubmit = () =>
	{
		console.log(form.getValues());
		
		const { _id, inquiry, action_type, collaborators, files } = form.getValues();
		
		let date = DateTime.utc().toISO();
		
		const new_action: Action = {
			...action_metadata,
			_id: _id,
			inquiry: inquiry,
			action_type: action_type,
			assigned_to: collaborators.map(x => x._id),
			created_at: date,
			created_by_user: current_user,
			status: ActionStatus.OPEN,
		};
		
		
		
		let attached_files = [];
		
		if(files.length)
		{
			
			files?.forEach(file_to_upload =>
			{
				let file_id = cuid();
				
				
				let file : StorageFile =
				{
					...action_metadata,
					_id: file_id,
					name: file_to_upload.name,
					path: `organizations/${claims.organization_id}/files/${file_id}`,
					size: file_to_upload.size,
					type: file_to_upload.type,
					upload_date: date,
					action_id: _id,
					last_modified: DateTime.fromMillis(file_to_upload.lastModified).toISO(),
				}
				
				
				uploadFile(file, file_to_upload, `organizations/${claims.organization_id}/files`);
				
				
				// // Create a reference to 'mountains.jpg'
				// const file_ref = ref(storage, file.path);
				
				// // 'file' comes from the Blob or File API
				// uploadBytes(file_ref, file_to_upload).then((snapshot) => {
				// 	console.log('Uploaded a blob or file!', file, file_to_upload);
				// });
				
				// write(`${org}/files`, file);
				
				
				attached_files.push(file);
			})
			
			
			let file_upload_event_text = 'Uploaded ' + files.length
				+ ' file' + ((files.length > 1) ? 's' : '');
			
			let file_upload_event : Event =
			{
				...action_metadata,
				_id: cuid(),
				name: file_upload_event_text,
				
				type: 'file',
				subtype: 'upload',
				
				datetime: date,
				summary:  file_upload_event_text,
				file_ids: attached_files?.map(x => x._id) || [],
				user_id: claims?.user_id,
			};
			
			write(`organizations/${claims.organization_id}/events`, file_upload_event);
		};
		
		
		
		let new_action_event_text = `${current_user.name} just created a new action item - ${inquiry}`
			
		let new_action_event : Event =
		{
			...action_metadata,
			_id: cuid(),
			name: new_action_event_text,
			
			type: 'action',
			subtype: 'create',
			
			datetime: date,
			summary:  new_action_event_text,
			action_id: _id,
			user_id: claims?.user_id,
		};
		
		write(`organizations/${claims.organization_id}/events`, new_action_event);
		write(`organizations/${claims.organization_id}/actions`, new_action);
		
		if(setCloseDialog) setCloseDialog(!closeDialog);
	};
	
	
	return (
		<FormProvider {...form}>
			
			<Stack
				direction='column'
				alignItems='center'
				justifyContent='flex-start'
				width='100%'
				spacing={1}
			>
				<Typography
					variant='subtitle1'
				>
					Create a new Action
				</Typography>
				
				<Stack
					direction='column'
					justifyContent='flex-start'
					alignItems='flex-start'
					spacing={2}
				>
					<Inquiry />
					<ActionCollaborators users={users} />
					
					<Divider sx={{ width: '80%' }} />
					
					<ActionTypeSelect />
					
					<Divider sx={{ width: '80%' }} />
					
					<Attachments control={control}/>
				</Stack>
				
				<Stack
					direction='row'
					width='100%'
					justifyContent='center'
					alignItems='center'
				>
						<Button
							variant='contained'
							onClick={handleSubmit}
						>
							Create
						</Button>
				</Stack>
			</Stack>
			
		</FormProvider>
	)
}


export default CreateAction;